import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritPartTwoVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPartTwoVehicleInformation/patchCulpritPartTwoVehicleInformation.type';

export const patchCulpritPartTwoVehicleInformationFunction = ({
  id,
  data,
}: PatchCulpritPartTwoVehicleInformationType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/culprit/vehicle_information/part_two/`,
    {
      ...data,
    },
  );
};
